var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSankey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9815 10.001L14.544 5.25098C14.6022 5.17335 14.6777 5.11035 14.7645 5.06696C14.8513 5.02357 14.947 5.00098 15.044 5.00098L17.8565 5.00098C18.0223 5.00098 18.1812 5.06682 18.2984 5.18403C18.4157 5.30125 18.4815 5.46022 18.4815 5.62598L18.4815 14.376C18.4815 14.5417 18.4157 14.7007 18.2984 14.8179C18.1812 14.9351 18.0223 15.001 17.8565 15.001L15.072 15.001C14.9754 15.001 14.8801 14.9786 14.7936 14.9355C14.7071 14.8925 14.6317 14.8299 14.5735 14.7529L10.9815 10.001Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9815 10.001L7.41901 5.25098C7.36079 5.17335 7.2853 5.11035 7.19852 5.06696C7.11173 5.02357 7.01603 5.00098 6.91901 5.00098L4.10651 5.00098C3.94075 5.00098 3.78177 5.06682 3.66456 5.18403C3.54735 5.30124 3.48151 5.46022 3.48151 5.62598L3.48151 14.376C3.48151 14.5417 3.54735 14.7007 3.66456 14.8179C3.78177 14.9351 3.94075 15.001 4.10651 15.001L6.89098 15.001C6.98761 15.001 7.08292 14.9786 7.16943 14.9355C7.25594 14.8925 7.33129 14.8299 7.38956 14.7529L10.9815 10.001Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSankey);
export default __webpack_public_path__ + "static/media/Sankey.80ac8f61a20738a330a38cf1d5cc5e14.svg";
export { ForwardRef as ReactComponent };